























import { Watch, Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class InputChoice extends Vue {
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly options!: Array<{label: string, value: string}>
    @Prop() readonly value!: any[]
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    internalValue: any[] = []

    created() {
        this.onExternalChange()
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    onInternalChange(): void {
        this.$emit('input', this.internalValue)
    }

    isSelected(option: {label: string, value: string}) {
        return this.internalValue.includes(option.value)
    }

    get componentClass(): object {
        return {
            'input-choice': true,
            'input-multi-choice': true,
        }
    }
}
